var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuProductsSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "#8285F8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#FCFCFC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 17.5,
    width: 11,
    height: 11,
    rx: 5.5,
    transform: "rotate(90 29 17.5)",
    fill: "#FCFCFC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1265 3.5669C15.5079 2.88277 16.4921 2.88277 16.8735 3.5669L22.5324 13.7185C22.9039 14.385 22.422 15.2054 21.6589 15.2054H10.3411C9.57798 15.2054 9.09608 14.385 9.46764 13.7185L15.1265 3.5669Z",
    fill: "#FCFCFC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#8285F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuProductsSelected);
export default __webpack_public_path__ + "static/media/menu-products-selected.e0f00a2beed2588f27de1f4518cbca0a.svg";
export { ForwardRef as ReactComponent };